/**
 * Orca Repositories List route — eagerly registers the route + `beforeLoad`
 * SSR loader but defers the component, atoms, and frame imports to `.lazy.tsx`
 * so the orca-admin chunk stays out of the entry bundle on every other route.
 * The orcaloops frame's sheet the lazy chunk's markup depends on comes from
 * `head()` here, as a `?url` link.
 *
 * The seam's `orcaReposBeforeLoad` hydrates `registryReposAtom` (under
 * `ORCA_REPOS_KEY`) and `seenReposAtom` (under `ORCA_SEEN_REPOS_KEY`), so the
 * list paints real rows on first paint without a client RPC round-trip.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

import { orcaReposBeforeLoad } from "~/lib/orca-ssr.ts";
import { orcaloopsStylesheetLinks } from "~/lib/orcaloops-head.ts";

/**
 * The route's `head()`: the orcaloops frame's sheet. Extracted so it is
 * unit-testable without the route machinery.
 *
 * @since 1.0.0
 */
export const reposHead = () => ({ links: orcaloopsStylesheetLinks });

export const Route = createFileRoute("/orca/repos/")({
  beforeLoad: orcaReposBeforeLoad,
  head: reposHead,
});
